import {useTranslation} from "react-i18next";
import {css, Theme} from "@emotion/react";
import {calculateRemSize, ph, pv, w100} from "@pg-design/helpers-css";
import {Tabs} from "@pg-design/tabs";
import {Text} from "@pg-design/text";

import {LANDING_MARKET_NEWS_COLORS} from "./landingMarketNews.constants";

const {panelDark, recommendedPanelBg} = LANDING_MARKET_NEWS_COLORS;

interface ILandingMarketNewsRecommendedProps {
    activeArticleId: string;
    onChange: (articleId: string) => void;
    tabs: Array<{title: string; value: string}>;
}

export const LandingMarketNewsRecommended = ({tabs, activeArticleId, onChange}: ILandingMarketNewsRecommendedProps) => {
    const {t} = useTranslation();

    return (
        <div css={panel}>
            <Text css={label} variant="headline_4" strong>
                {t("landing.market_news.recommended")}
            </Text>

            <Tabs
                css={tabsStyles}
                color="gray"
                fullWidth
                onChange={onChange}
                tabs={tabs}
                value={activeArticleId}
                variant="contained"
            />
        </div>
    );
};

const panel = css`
    display: flex;
    flex-direction: column;
    align-items: stretch;
    gap: 12px;
    box-sizing: border-box;
    ${w100};
    min-width: 0;
    overflow: hidden;
    ${pv(2)};
    ${ph(7)};
    border-radius: 16px;
    background: ${recommendedPanelBg};
    color: ${panelDark};
`;

const label = css`
    margin: 0;
    color: ${panelDark};
`;

const tabsStyles = (theme: Theme) => css`
    align-self: stretch;
    ${w100};
    min-width: 0;
    overflow: hidden;

    & > div {
        ${w100};
        min-width: 0;
        max-width: 100%;
    }

    & > div > div {
        display: flex;
        ${w100};
        min-width: 0;
    }

    /* Taby rozciągają się do wysokości najwyższego (flex stretch), więc tytuł centrujemy w środku. */
    [data-name="tab-title"] {
        display: flex;
        align-items: center;
        justify-content: center;
        flex: 1 1 0;
        min-width: 0;
        max-width: 100%;
        height: auto;
        box-sizing: border-box;
        padding: ${calculateRemSize(1)} !important;
        line-height: 1.35;
        white-space: normal !important;
        overflow: hidden;
        word-break: break-word;
        overflow-wrap: anywhere;
        text-align: center;
    }

    @media (max-width: ${theme.breakpoints.sm}) {
        [data-name="tab-title"] {
            -webkit-box-align: start;
            text-align: left;
        }
    }
`;
